import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import { configurePdfWorker } from './app/shared/config/pdf-worker.config';
import { environment } from './environments/environment';
import { ApiCoreService } from './app/shared/services/api-core.service';
import { MatrixService } from './app/shared/services/matrix.service';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideEffects } from '@ngrx/effects';
import { AppEffects } from './app/_state/effects/app.effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideStore } from '@ngrx/store';
import { reducers, metaReducers } from './app/_state/reducers/index';
import { NgxUiLoaderModule, NgxUiLoaderConfig, POSITION, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';
import { AppComponent } from './app/app.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
	bgsColor: '#2b0d61',
	bgsOpacity: 0.5,
	bgsPosition: POSITION.bottomCenter,
	bgsSize: 40,
	bgsType: SPINNER.ballSpinClockwise, // background spinner type
	fgsType: SPINNER.ballScaleMultiple, // foreground spinner type
	pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
	pbThickness: 3, // progress bar thickness
	text: '... CARGANDO',
	textColor: '#2b0d61',
	textPosition: 'center-center',
	pbColor: '#2b0d61',
	overlayColor: 'rgba(40,40,40,0.26)',
	fgsColor: '#2b0d61',
	blur: 3,
	delay: 0,
	fastFadeOut: true,
};



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => configurePdfWorker(),
            multi: true,
        },
        importProvidersFrom(
            BrowserModule,
            AppRoutingModule,
            BrowserAnimationsModule,
            NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        ),
        provideStore(reducers, { metaReducers }),
        provideEffects(AppEffects),
        provideStoreDevtools({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true,
        }),
        ApiCoreService,
        MatrixService,
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        ...provideLuxonDateAdapter(),
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
  .catch(err => console.error(err));
